export default [
    {
        icon: 'GridIcon',
        route: 'post-op',
        title: 'PostOp'
    },
]
